import React from "react";
import "./THero.sass";
import tendies from "./../../../assets/images/tendies2.png";

export default function THero() {
  return (
    <div className="thero">
      <div className="thero-bg">
        <div className="thero-container">
          <div className="thero-img">
            <img src={tendies} alt="" />
          </div>
          <div className="thero-text">
            <h1 className="thero-title">
              Good Boys Get TENDIES! <br /> <br />
              <span>
                {" "}
                Yum Yum! <br /> <br className="not-mobile" /> Gimme Gimme
                TENDIES!
              </span>
            </h1>
            <p className="thero-description">
              If an Ape’s favorite food is Bananas, a Frog’s favorite food is
              Chicken Tendies! Through belief in Kek, the Frens are granted the
              Holy TENDIES of Eternal Gains and offered Holy protection from the
              dreaded Wage Cage. <br /> <br />
              And Kek said unto them, I am the Tendies of gains: Frens that
              cometh to me shall never WageSlave; and Frens that believeth on me
              shall never WageCuck.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
